import { render } from "./IndividualInfoSchoolchild.vue?vue&type=template&id=5303fbce&scoped=true"
import script from "./IndividualInfoSchoolchild.vue?vue&type=script&lang=js"
export * from "./IndividualInfoSchoolchild.vue?vue&type=script&lang=js"

import "./IndividualInfoSchoolchild.vue?vue&type=style&index=0&id=5303fbce&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5303fbce"]])

export default __exports__